import { Clock, ShoppingCart, Utensils, Zap, Check, X, Undo2 } from 'lucide-react';

export const formatPrice = (price) => {
  return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(price);
};

export const formatTime = (isoString) => {
  if (!isoString) return 'N/A';
  const date = new Date(isoString);
  return date.toLocaleString('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Returns today's date as a local YYYY-MM-DD string (avoids the UTC shift that
// `new Date().toISOString()` introduces late at night in western timezones).
export const getTodayLocal = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Returns the date `days` days before today as a local YYYY-MM-DD string.
export const getDateOffsetLocal = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatStatus = (status) => {
  const map = {
    pending: { label: 'Pendente', color: 'bg-status-canceled-soft text-status-canceled border-status-canceled/30', icon: <Clock size={16} /> },
    received: { label: 'Novo Pedido', color: 'bg-accent-2/15 text-accent-2 border-accent-2/30', icon: <ShoppingCart size={16} /> },
    preparing: { label: 'A Preparar', color: 'bg-brand-soft text-brand border-brand/30', icon: <Utensils size={16} /> },
    'ready-to-pickup': { label: 'Pronto p/ Levantamento', color: 'bg-status-completed-soft text-status-completed border-status-completed/30', icon: <Zap size={16} /> },
    'on-delivery': { label: 'Em Entrega', color: 'bg-chart-6/15 text-chart-6 border-chart-6/30', icon: <Zap size={16} /> },
    completed: { label: 'Concluído', color: 'bg-surface-2 text-muted border-border', icon: <Check size={16} /> },
    cancelled: { label: 'Cancelado', color: 'bg-status-canceled-soft text-status-canceled border-status-canceled/30', icon: <X size={16} /> },
    // Cores da família dos reembolsos, as mesmas do aviso "Pedido de reembolso",
    // e não o vermelho de "Cancelado": um reembolso não é uma desistência do
    // cliente, e nas estatísticas os dois não valem o mesmo.
    refunded: { label: 'Reembolsado', color: 'bg-status-pending-soft text-status-pending border-status-pending/30', icon: <Undo2 size={16} /> },
  };
  return map[status] || { label: status, color: 'bg-surface-2 text-muted border-border', icon: null };
};

export const getNextStatus = (currentStatus, orderType) => {
  switch (currentStatus) {
    case 'pending':
    case 'received':
      return { next: 'preparing', label: 'Iniciar Preparação', icon: <Utensils size={16} /> };
    case 'preparing':
      if (orderType === 'pickup') {
        return { next: 'ready-to-pickup', label: 'Pronto p/ Levantamento', icon: <Zap size={16} /> };
      }
      if (orderType === 'delivery') {
        return { next: 'on-delivery', label: 'Enviar p/ Entrega', icon: <Zap size={16} /> };
      }
      return { next: 'ready-to-pickup', label: 'Marcar como Pronto', icon: <Zap size={16} /> };
    case 'ready-to-pickup':
    case 'on-delivery':
      return { next: 'completed', label: 'Finalizar Pedido', icon: <Check size={16} /> };
    default:
      return null;
  }
};
